import React from 'react';
import { InputNumber } from 'primereact/inputnumber';

const CurrencyField = ({ field, form, onChange, ...restProps }) => {
  const handleChange = (e) => {
    const { value } = e;

    form.setFieldValue(field.name, value);

    if (onChange) {
      onChange(value);
    }
  };

  const handleBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  return (
    <InputNumber
      suffix=" BHD"
      {...field}
      {...restProps}
      onChange={handleChange}
      onBlur={handleBlur}
      currencyDisplay="name"
      minFractionDigits={3}
      maxFractionDigits={3}
    />
  );
};

export default React.memo(CurrencyField);
